import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Mail } from "lucide-react";

export default function NeonGlobalFooter() {
  const currentYear = new Date().getFullYear();

  const platformLinks = [
    { name: "OnlyFans", url: "https://onlyfans.com/giopilos" },
    { name: "JustForFans", url: "https://justfor.fans/giopilos" },
    { name: "Faphouse", url: "https://faphouse.com/giopilos" },
  ];

  const socialLinks = [
    { name: "Twitter", url: "https://twitter.com/giopilos" },
    { name: "Instagram", url: "https://instagram.com/giopilos" },
    { name: "Telegram", url: "https://t.me/giopilos" },
  ];

  const companyLinks = [
    { name: "About", path: "/about" },
    { name: "FAQ", path: "/faq" },
    { name: "Updates", path: "/updates" },
  ];

  const legalLinks = [
    { name: "Legal Hub", path: "/legal" },
    { name: "Terms of Service", path: "/terms" },
    { name: "Privacy Policy", path: "/privacy" },
    { name: "Takedown / DMCA", path: "/takedown" },
    { name: "Deletion", path: "/user-deletion" },
  ];

  return (
    <footer 
      className="border-t border-white/5 py-12 px-6"
      style={{ background: '#000000' }}
    >
      <div className="max-w-7xl mx-auto">
        
        {/* Top Section - Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-12 mb-12">
          
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-2xl font-bold mb-3 text-purple-400">
              GioPilos
            </h3>
            <p className="text-sm text-zinc-500 leading-relaxed">
              Premium exclusive content. Browse free, upgrade on your favorite platform.
            </p>
          </div>

          {/* Platforms */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-xs text-zinc-600">
              Watch On
            </h4>
            <ul className="space-y-2">
              {platformLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                  >
                    {link.name}
                    <ExternalLink size={12} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-xs text-zinc-600">
              Follow
            </h4>
            <ul className="space-y-2">
              {socialLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-xs text-zinc-600">
              Company
            </h4>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Support */}
          <div>
            <h4 className="font-semibold mb-4 uppercase tracking-wider text-xs text-zinc-600">
              Legal
            </h4>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="mailto:privacy@giopilos.com"
                  className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-purple-400 transition-colors"
                >
                  <Mail size={14} />
                  Privacy Inquiries
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-white/5 my-8" />

        {/* Bottom Section - Copyright & Quick Links */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <p className="text-sm text-zinc-600">
            © {currentYear} GioPilos. All rights reserved.
          </p>

          {/* Quick Links */}
          <div className="flex items-center gap-6 text-sm">
            <span className="text-red-400 font-semibold">18+ Platform</span>
            <Link 
              to="/" 
              className="text-zinc-500 hover:text-purple-400 transition-colors"
            >
              Home
            </Link>
            <Link 
              to="/legal" 
              className="text-zinc-500 hover:text-purple-400 transition-colors"
            >
              Legal Hub
            </Link>
            <Link 
              to="/members/login" 
              className="text-zinc-500 hover:text-purple-400 transition-colors"
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
